import {createEntityMeta,SyncStatus} from '../offline/entity.js';
import {
  createTemperatureReading,
  orderTemperatureReadings
} from './temperature-reading.js';

export const TEMPERATURE_READING_ENTITY_TYPE='temperature_reading';

function required(value,label){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

export function createTemperatureReadingStore({
  repository,
  queue,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.list||!repository?.put)throw new TypeError('repository with get/list/put is required');
  if(!queue?.enqueue)throw new TypeError('sync queue is required');
  const owner=required(userId,'userId');

  async function get(id){
    const row=await repository.get(TEMPERATURE_READING_ENTITY_TYPE,required(id,'id'));
    if(!row)return null;
    if(row.userId!==owner)throw new Error('TEMPERATURE_READING_OWNER_MISMATCH');
    return Object.freeze(row);
  }

  async function list(sessionId,{itemId=undefined,readingKind=null}={}){
    const session=required(sessionId,'sessionId');
    const rows=await repository.list(TEMPERATURE_READING_ENTITY_TYPE);
    const owned=(rows||[])
      .filter(row=>row.userId===owner&&row.sessionId===session)
      .filter(row=>itemId===undefined||row.itemId===(itemId||null))
      .filter(row=>!readingKind||row.readingKind===readingKind);

    const ordered=orderTemperatureReadings(owned);
    const byId=new Map(owned.map(row=>[row.id,row]));
    return Object.freeze(ordered.map(value=>Object.freeze({...byId.get(value.id),...value})));
  }

  async function append(sessionId,input={}){
    const session=required(sessionId,'sessionId');
    const reading=createTemperatureReading({
      ...input,
      userId:owner,
      sessionId:session,
      recordedAt:input.recordedAt||now()
    });
    const existing=await repository.get(TEMPERATURE_READING_ENTITY_TYPE,reading.id);
    if(existing)throw new Error('TEMPERATURE_READING_ALREADY_EXISTS');
    const entity={
      ...createEntityMeta({id:reading.id,now:now(),syncStatus:SyncStatus.PENDING_CREATE}),
      ...reading
    };
    return queue.enqueue(TEMPERATURE_READING_ENTITY_TYPE,entity,'create');
  }

  async function correct(readingId,input={}){
    const original=await get(readingId);
    if(!original)throw new Error('TEMPERATURE_READING_NOT_FOUND');
    const correctionId=String(input.id||'').trim();
    if(correctionId&&correctionId===original.id)throw new TypeError('Correction requires a new reading id');
    return append(original.sessionId,{
      readingKind:original.readingKind,
      itemId:original.itemId,
      probeId:original.probeId,
      sourceType:original.sourceType,
      sourceTransport:original.sourceTransport,
      sourceRef:original.sourceRef,
      ...input,
      correctsReadingId:original.id
    });
  }

  return Object.freeze({append,correct,get,list});
}
